import {
  alpha,
  Box,
  Container,
  Link,
  Typography,
  useTheme,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

function Footer() {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: { xs: 2, sm: 3, md: 4 },
        px: { xs: 2, sm: 3, md: 4 },
        mt: "auto",
        backgroundColor: alpha(theme.palette.primary.main, 0.02),
        borderTop: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
      }}
    >
      <Container maxWidth="lg" disableGutters={false}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            gap: { xs: 1.5, sm: 2 },
            textAlign: { xs: "center", sm: "left" },
          }}
        >
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
          >
            © {currentYear} Sistema de Licenciamento Ambiental
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              gap: { xs: 1, sm: 0 },
            }}
          >
            <Link
              component={RouterLink}
              to="/termos-de-uso"
              color="inherit"
              sx={{
                mx: { xs: 0, sm: 1.5 },
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                color: "text.secondary",
                textDecoration: "none",
                "&:hover": {
                  color: theme.palette.primary.main,
                },
              }}
            >
              Termos de Uso
            </Link>
            <Link
              component={RouterLink}
              to="/contato"
              color="inherit"
              sx={{
                mx: { xs: 0, sm: 1.5 },
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                color: "text.secondary",
                textDecoration: "none",
                "&:hover": {
                  color: theme.palette.primary.main,
                },
              }}
            >
              Contato
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
